import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  custom: {
    fontFamily: 'Segoe UI !important',
    fontWeight: 'normal',
    fontSize: 'inherit'
  }
});

const CustomTabs = ({ children, page, index }) =>  {
  const classes = useStyles();
  return (
    <Typography
      component='div'
      role='tabpanel'
      hidden={page !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      className={classes.custom}
    >
      <Box p={1}>{children}</Box>
    </Typography>
  );
}

CustomTabs.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired
};

export default CustomTabs;
